import WaitingListApi from "../api-legacy/WaitingListApi";
import * as ActionType from "../actionTypes/recallListActionTypes";

import { startLoader, stopLoader } from "./loaderActions";
import { getCompanyEndOfDay, getCompanyStartOfDay } from "../helpers/DateUtils";
import { SET_MISSED_CANCELLED_LIST_FORM_VALUES } from "../actionTypes/waitingListActionTypes";

const getActiveDoctorIds = (doctors) => {
  return (
    doctors
      .filter((x) => x.active)
      .map((x) => x.id)
      .join(",") || undefined
  );
};

const formatDoctorIds = (doctorIds) => {
  return (
    (doctorIds || [])
      .filter((x) => x.value !== 0)
      .map((x) => x.value)
      .join(",") || undefined
  );
};

const buildRecallListRequestData = ({
  doctors,
  values,
  start,
  listLength,
  fromDate,
  toDate,
  missedCancelledFormValues,
}) => {
  const data = {
    createdSourceCode: "FROM_FOLLOW_UP",
    limit: 50,
    withTotalCount: true,
    doctorIds: getActiveDoctorIds(doctors),
  };

  if (values) {
    data.noAnswer = values.noAnswer;
    data.willCall = values.willCall;
    data.notInterested = values.notInterested;
    data.requestedReschedule = values.requestedReschedule;
    data.clinicId = values.clinicId ?? values?.clinic?.value;
    data.periodStart = getCompanyStartOfDay(values.periodStart);
    data.periodEnd = getCompanyEndOfDay(values.periodEnd);
    data.start = start === 0 ? start : listLength;
    data.doctorIds = formatDoctorIds(values.doctorIds);
    data.categoryIds = values.categoryIds.map((v) => v.value).join(",") || undefined;
  } else {
    data.clinicId = missedCancelledFormValues?.clinic?.value;
    data.periodStart = getCompanyStartOfDay(fromDate);
    data.periodEnd = getCompanyEndOfDay(toDate);
    data.start = listLength;
    data.doctorIds = formatDoctorIds(missedCancelledFormValues.doctorIds);
  }

  return data;
};

export function getRecallList(values, start) {
  return function (dispatch, getState) {
    const {
      auth: { doctors },
      recallList: { fromDate, toDate, listTotal, list, loading },
      waitingList: { missedCancelledFormValues },
    } = getState();

    if ((!start === 0 && list.length === listTotal) || loading) {
      return;
    }

    dispatch(startLoader());

    const data = buildRecallListRequestData({
      doctors,
      values,
      start,
      listLength: list.length,
      fromDate,
      toDate,
      missedCancelledFormValues,
    });

    if (values) {
      dispatch({
        type: SET_MISSED_CANCELLED_LIST_FORM_VALUES,
        values,
      });
    }

    dispatch(getRecallListApi(data))
      .then(() => {
        dispatch(stopLoader());
      })
      .catch((error) => {
        dispatch(stopLoader(error));
      });
  };
}

export function loadRecallList(values) {
  return function (dispatch, getState) {
    const {
      auth: { doctors },
      recallList: { fromDate, toDate, listTotal, list, loading },
      waitingList: { missedCancelledFormValues },
    } = getState();

    if (list.length === listTotal || loading) {
      return;
    }
    dispatch(startLoader());

    const data = buildRecallListRequestData({
      doctors,
      values,
      start: list.length,
      listLength: list.length,
      fromDate,
      toDate,
      missedCancelledFormValues,
    });

    if (values) {
      dispatch({
        type: SET_MISSED_CANCELLED_LIST_FORM_VALUES,
        values,
      });
    }

    dispatch(loadRecallListApi(data))
      .then(() => {
        dispatch(stopLoader());
      })
      .catch((error) => {
        dispatch(stopLoader(error));
      });
  };
}

export function setFromDate(data) {
  return {
    type: ActionType.SET_RECALL_LIST_FROM_DATE,
    date: data,
  };
}

export function setToDate(data) {
  return {
    type: ActionType.SET_RECALL_LIST_TO_DATE,
    date: data,
  };
}

function getRecallListApi(data) {
  return {
    api: WaitingListApi.getList,
    types: [
      ActionType.GET_RECALL_LIST_START,
      ActionType.GET_RECALL_LIST_SUCCESS,
      ActionType.GET_RECALL_LIST_ERROR,
    ],
    data,
  };
}

function loadRecallListApi(data) {
  return {
    api: WaitingListApi.getList,
    types: [
      ActionType.LOAD_RECALL_LIST_START,
      ActionType.LOAD_RECALL_LIST_SUCCESS,
      ActionType.LOAD_RECALL_LIST_ERROR,
    ],
    data,
  };
}
